export default __webpack_public_path__ + "static/media/user_search.d63a6553.svg";